import { IconButton, Tooltip } from '@mui/material';
import React, { forwardRef } from 'react';

const baseSx = {
  border: 1,
  borderColor: 'var(--button-outline-border)',
  borderRadius: 'var(--button-radius)',
  backgroundColor: 'var(--surface-primary)',
  width: 'var(--filter-chip-height)',
  height: 'var(--filter-chip-height)',
  boxShadow: 'var(--card-shadow-raised)',
  transition:
    'background-color var(--duration-normal) var(--easing-standard), border-color var(--duration-normal) var(--easing-standard), box-shadow var(--duration-fast) var(--easing-standard)',
  '&:hover': {
    backgroundColor: 'var(--interactive-hover)',
    borderColor: 'var(--button-outline-border-hover)',
    boxShadow: 'var(--card-shadow-raised-hover)',
  },
  '&:active': {
    boxShadow: 'var(--card-shadow-raised-active)',
  },
  '&.Mui-disabled': {
    backgroundColor: 'var(--button-disabled-bg)',
    color: 'var(--button-disabled-color)',
    borderColor: 'var(--button-disabled-color)',
    boxShadow: 'none',
  },
};

const ToolbarIconButton = forwardRef(function ToolbarIconButton({ tooltip, children, sx, disabled, ...rest }, ref) {
  const button = (
    <IconButton ref={ref} size="small" disabled={disabled} sx={{ ...baseSx, ...sx }} {...rest}>
      {children}
    </IconButton>
  );

  if (!tooltip) return button;

  return <Tooltip title={tooltip}>{disabled ? <span>{button}</span> : button}</Tooltip>;
});

export default ToolbarIconButton;
